import { render, staticRenderFns } from "./DontSendRequest.vue?vue&type=template&id=9c52e0f2&"
import script from "./DontSendRequest.vue?vue&type=script&lang=js&"
export * from "./DontSendRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports